import { Component, Emit, Model, Prop, Vue } from 'vue-property-decorator';
import { Report } from '@/models/Report';
import FeedbackList from '@/components/FeedbackList/FeedbackList.vue';

@Component<Feedback>({
  components: {
    FeedbackList,
  },
})
export default class Feedback extends Vue {
  protected $pageTitle = 'Feedback';

  @Model('report', { default: () => new Report() })
  protected report!: Report;

  @Model('readOnly', { default: false })
  protected readOnly = false;

  @Prop({ default: false })
  protected syncing!: boolean;
}
